import { createContext } from 'react';
const Template = createContext(undefined);
export default Template;
